<template>
    <div class="elle-news-grid padd-v-top">
        <div class="elle-news-grid--grid">
            <CardsBlankPost v-for="index in 8" :key="index" />
        </div>
    </div>
</template>

<script setup lang="ts"></script>
